import { Wrapper, Width } from './styles'
import Text from 'components/shared/Text'
import Icon from 'components/shared/Icon'
import { ButtonVariant } from 'styles/types'
import { useResolutions } from 'store/resolutions'
import ButtonLoader from 'components/shared/Button/ButtonLoader'
import { DefaultTheme } from 'styled-components'

interface ButtonProps {
    children: React.ReactNode
    variant?: ButtonVariant
    isDisabled?: boolean
    type?: 'button' | 'submit' | 'reset'
    onClick?: () => void
    hasArrow?: boolean
    isIconOnly?: boolean
    width?: Width | [Width, Width]
    isLoading?: boolean
    href?: string | undefined
    hasNoWrap?: boolean
    htmlFor?: string
    as?: 'label'
    theme?: DefaultTheme
    target?: string
    rel?: string
    testId?: string
    isFocusable?: boolean
}

const Button = ({
    children,
    variant = 'primary',
    isDisabled,
    type = 'button',
    onClick,
    hasArrow = true,
    isIconOnly = false,
    width,
    isLoading,
    href,
    hasNoWrap,
    as,
    htmlFor,
    theme,
    target,
    rel,
    testId,
    isFocusable = true,
}: ButtonProps) => {
    const { isTablet } = useResolutions()
    const displayAs = href ? 'a' : as || 'button'

    return (
        <Wrapper
            disabled={!!isDisabled || isLoading}
            type={type}
            onClick={onClick}
            variant={variant}
            isIconOnly={isIconOnly}
            width={width}
            href={href}
            as={displayAs}
            hasArrow={hasArrow}
            isLoading={isLoading}
            htmlFor={htmlFor}
            theme={theme}
            target={target}
            rel={rel}
            data-testid={testId}
            tabIndex={isFocusable ? 0 : -1}
        >
            {!(isIconOnly && isLoading) && (
                <Text variant="bodyStrong" hasNoWrap={hasNoWrap}>
                    {isLoading && <ButtonLoader />}
                    {children}
                </Text>
            )}

            {hasArrow && !isIconOnly && (
                <Icon variant="arrow" size={isTablet ? 20 : 24} />
            )}
        </Wrapper>
    )
}

export default Button
